<template>
  <div class="t-page">
    <div class="left">
      <div class="section-header">
        <h2 class="section-title"> My Exams</h2>
        <div class="search-box">
            <i class="fas el-icon-search"></i>
            <i class="fas el-icon-close" @click="clearSearchVal"></i>
            <input type="text" placeholder="Search Exams..." v-model="searchVal" @input="searchQuestion">
        </div>
      </div>
      <div class="filter-tabs">
          <div :class="['filter-tab', index === 0 ? 'active': null]" @click="getFilter('All')">All Exams</div>
          <div :class="['filter-tab', index === 1 ? 'active': null]" @click="getFilter('Pending')">Pending</div>
          <div :class="['filter-tab', index === 2 ? 'active': null]" @click="getFilter('Passed')">Passed</div>
          <div :class="['filter-tab', index === 3 ? 'active': null]" @click="getFilter('Failed')">Failed</div>
          <div :class="['filter-tab', index === 4 ? 'active': null]" @click="getFilter('Completed')">Completed</div>
      </div>
      <div class="exam-list">
        <div class="exam-card" v-for="item in examList" :key="item.id">
            <div class="exam-header">
                <div class="exam-title">{{ item.name }}</div>
                <div class="exam-meta">
                    <span>NO. {{ item.id }}</span>
                    <span>{{ item.duration }} Minutes</span>
                </div>
            </div>
            <div class="exam-body">
                <div class="exam-info">
                    <span><i class="far fa-calendar"></i>{{ item.startTime | filterDate }}</span>
                    <span><i class="far fa-question-circle"></i> {{ item.questionsCount }} questions</span>
                </div>
                <p class="exam-desc">{{ item.description }}</p>
                <div class="exam-footer">
                    <span :class="['exam-status', getStyle(item.status)]">{{ item.status }}</span>
                    <template v-if="item.status !== 'Passed'">
                        <button class="btn" v-if="item.examsCount < item.examsNumber" @click="toExam(item.id)">Start Exam</button>
                    </template>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div class="right">
        <div class="info-card">
            <h3 class="card-title"><i class="fas el-icon-s-data"></i>Exam Progress</h3>
            <div class="progress-item">
                <div class="progress-header"> <span>Exams Completed</span> <span>{{ `${finshed} / ${allExamLength}` }}</span> </div>
                <div class="t-progress-bar">
                    <div class="t-progress-fill" :style="{'width': `${(finshed / allExamLength) * 100}%`}"></div>
                </div>
            </div>
            <div class="progress-item">
                <div class="progress-header"> <span>Average Score</span> <span>{{ avg }}</span> </div>
                <div class="t-progress-bar">
                    <div class="t-progress-fill" :style="{'width': `${avg}%`}"></div>
                </div>
            </div>
            <div class="stats-grid">
                <div class="stat-card">
                    <div class="stat-value">{{ (((passed / allExamLength) || 0) * 100).toFixed(2) }}%</div>
                    <div class="stat-label">Pass Rate</div>
                </div>
                <div class="stat-card">
                    <div class="stat-value">{{ unfinished }}</div>
                    <div class="stat-label">Pending</div>
                </div>
                <div class="stat-card">
                    <div class="stat-value">{{ finshed }}</div>
                    <div class="stat-label">Completed</div>
                </div>
            </div>
        </div>
        <div class="info-card">
            <h3 class="card-title"><i class="fas el-icon-s-marketing"></i>Recent Scores</h3>
            <div class="info-item" v-for="(item, index) in record" :key="index">
                <span class="info-label">{{ item.examTitle }} {{ getOrdinal(item.number) }}</span>
                <span class="info-value">{{ item.score }}</span>
            </div>
        </div>
        <div class="info-card">
            <h3 class="card-title"><i class="fas el-icon-star-on"></i>Certificates</h3>
            <div class="info-item" v-for="(item, index) in certificates" :key="index">
                <span class="info-label">{{ item.title }}</span>
                <div class="info-value">
                    <span v-if="item.status === '已拥有'" class="el-icon-download btn-downl" v-loading.fullscreen.lock="fullscreenLoading" @click="downCertificate(item)"></span>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { getExamUserInfo, getExamRecord, getCertificateByStudent } from '@/api/exam'
import * as PDFLib from 'pdf-lib';

export default {
    name: 'ExamIndex',
    data() {
        return {
            examList: [],
            examListBak: [],
            allExamLength: 0,
            avg: 0,
            finshed: 0,
            unfinished: 0,
            passed: 0,
            record: [],
            index: 0,
            searchVal: '',
            searchTimer: null,
            certificates: [],
            fullscreenLoading: false,
            examWindow: null
        }
    },
    async mounted() {
        if (!this.$store.state.client.user.id) {
            this.$router.push({path: '/login'})
            return false;
        }
        await this.getExamUserInfo()
        await this.getExamRecord()
        await this.getCertificateByStudent()
    },
    methods: {
        async downCertificate(data) {
            this.fullscreenLoading = true;
            let options = JSON.parse(data.options)
            try {
                const response = await fetch(data.url)
                if (!response.ok) throw new Error('模板下载失败');
                const templateBytes = await response.arrayBuffer();

                const pdfDoc = await PDFLib.PDFDocument.load(templateBytes);

                const form = pdfDoc.getForm();

                let fillData = this.hanldOtions(options, data)
                for (const [fieldName, value] of Object.entries(fillData)) {
                    const field = form.getFieldMaybe(fieldName);
                    if (!field) {
                        console.warn(`未找到表单域: ${fieldName}`);
                        continue;
                    }
                    // 使用 instanceof 判断类型
                    if (field instanceof PDFLib.PDFTextField) {
                        field.setText(String(value));
                        // console.log(field.getName(), '文本域填充:', value);
                    } 
                    else if (field instanceof PDFLib.PDFCheckBox) {
                        if (value === true || value === 'true') field.check();
                        else field.uncheck();
                    }
                    else if (field instanceof PDFLib.PDFRadioGroup) {
                        // 单选框：value 应为选项值
                        field.select(value);
                    }
                    else if (field instanceof PDFLib.PDFDropdown) {
                        // 下拉框
                        field.select(value);
                    }
                    else if (field instanceof PDFLib.PDFOptionList) {
                        // 列表框
                        field.select(value);
                    }
                    else if (field instanceof PDFLib.PDFButton) {
                        // 按钮一般不需填充
                        console.warn(`按钮字段 ${fieldName} 不支持填充`);
                    }
                    else {
                        // 兼容降级：尝试调用 setText（某些字段可能通用）
                        if (typeof field.setText === 'function') {
                            field.setText(String(value));
                        } else {
                            console.warn(`未知字段类型: ${field.constructor.name}, 字段名: ${fieldName}`);
                        }
                    }
                }
                form.flatten()
                this.fullscreenLoading = false;
                // 4. 保存并下载
                const pdfBytes = await pdfDoc.save();
                const blob = new Blob([pdfBytes], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `certificate_${Date.now()}.pdf`;
                link.click();
                URL.revokeObjectURL(url);
            } catch (e) {
                console.error(err);
                this.fullscreenLoading = false;
            }
        },
        hanldOtions(options, data) {
            let form = {}
            for (const [fieldName, templateValue] of Object.entries(options)) {
                // 非占位符格式，直接返回（固定值/默认值）
                if (typeof templateValue !== 'string' || !templateValue.startsWith('@') || !templateValue.endsWith('@')) {
                    form[fieldName] = templateValue
                }
                const keyword = templateValue.slice(1, -1); // 去掉 @
                if (keyword === 'name') {
                    form[fieldName] = this.$store.state.client.user.name
                }
                if (keyword === 'date') {
                    form[fieldName] = (data.issuedAt).split(' ')[0]
                }
            }
            return form
        },
        clearSearchVal() {
            this.searchVal = ''
            this.examList = this.examListBak
        },
        searchQuestion(value) {
            // 清除之前的定时器
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            if (this.searchVal == '') {
                this.examList = this.examListBak
                return;
            }
            // 设置新的定时器
            this.searchTimer = setTimeout(() => {
                this.examList = this.examListBak.filter(item => {
                    return item.name.includes(this.searchVal)
                })
            }, 500);
        },
        getOrdinal(n) {
            const s = ["th", "st", "nd", "rd"];
            const v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        },
        getFilter(status) {
            if (status === 'All') {
                this.examList = this.examListBak
                this.index = 0
            }
            if (status === 'Failed') {
                this.examList = this.examListBak.filter(item => {
                    return item.status === 'Failed'
                })
                this.index = 3
            }
            if (status === 'Passed') {
                this.examList = this.examListBak.filter(item => {
                    return item.status === 'Passed'
                })
                this.index = 2
            }
            if (status === 'Unfinished') {
                this.examList = this.examListBak.filter(item => {
                    return item.status === 'Unfinished'
                })
                this.index = 1
            }
            if (status === 'Pending') {
                this.examList = this.examListBak.filter(item => {
                    return item.status === 'Pending'
                })
                this.index = 1
            }
            if (status === 'Completed') {
                this.examList = this.examListBak.filter(item => {
                    return ['Passed','Failed'].includes(item.status)
                })
                this.index = 4
            }
            
        },
        toExam(id) {
            // this.$router.push({path: `/exam/${id}/taking`})
            const width = window.screen.availWidth;
            const height = window.screen.availHeight;
            // const left = (window.screen.availWidth - width) / 2
            // const top = (window.screen.availHeight - height) / 2
            const win = window.open(
                `/exam/${id}/taking`,
                'examWindow',
                `width=${width},height=${height},left=0,top=0,menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes`
            );
            if (!win) {
                this.$message.error('Popup blocked. Please allow popups for this site.')
            }
            this.examWindow = win

            // 监听子窗口消息
            const handler = (event) => {
            // 安全校验：确保消息来自子窗口
            if (event.source !== win) return
            const data = event.data
            if (data && data.type === 'examSubmitted') {
                // 子窗口已提交，刷新父页面数据
                this.$message.success(`Exam ${data.examId} has been submitted. Refreshing...`)
                this.fetchExamList() // 重新加载考试列表
                // 可选：移除监听，避免重复
                window.removeEventListener('message', handler)
            }
            }
            window.addEventListener('message', handler)

            // 窗口关闭时移除监听（可选）
            const checkClosed = setInterval(() => {
            if (win.closed) {
                clearInterval(checkClosed)
                window.removeEventListener('message', handler)
                this.examWindow = null
            }
            }, 1000)
        },
        async fetchExamList() {
            await this.getExamUserInfo()
            await this.getExamRecord()
            await this.getCertificateByStudent()
        },
        getStyle(status) {
            if (status === 'Failed') return 'status-failed'
            if (status === 'Passed') return 'status-completed'
            if (status === 'Unfinished') return 'status-pending'
            if (status === 'Pending') return 'status-pending'
        },
        async getCertificateByStudent() {
            const {data: {data, isSuccess}} = await getCertificateByStudent()
            if (isSuccess) {
                this.certificates = data
            }
        },
        async getExamUserInfo() {
            const {data: {data, isSuccess}} = await getExamUserInfo()
            if (isSuccess) {
                // console.log(data)
                this.examListBak = data.examInfos
                this.examList = this.examListBak
                // 统计考试信息
                let count = data.examInfos.length
                let finshed = 0
                let unfinished = 0
                let passed = 0
                let sum = 0;
                for (let item of data.examInfos) {
                    if (item.status === 'Failed' || item.status === 'Passed') {
                        finshed += 1
                        sum += item.score
                        if (item.status === 'Passed') {
                            passed += 1
                        }
                    } else {
                        unfinished += 1
                    }
                }
                let avg = finshed === 0 ? 0 : (sum / finshed);

                this.allExamLength = count
                this.finshed = finshed
                this.unfinished = unfinished
                this.avg = avg
                this.passed = passed
            }
        },
        async getExamRecord() {
            const {data: {data, isSuccess}} = await getExamRecord()
            if (isSuccess) {
                this.record = data
            }
        }
    },
    beforeDestroy() {
        // 清理
        if (this.examWindow && !this.examWindow.closed) {
            this.examWindow.close()
        }
        // 移除可能残留的监听
        window.removeEventListener('message', this._examMessageHandler)
    },
    filters: {
        filterDate(value) {
            return value.split(' ')[0]
        }
    }
}
</script>

<style lang="scss" scoped>
  input:not([type="image" i], [type="range" i], [type="checkbox" i], [type="radio" i]) {
    overflow-clip-margin: 0px !important;
    overflow: clip !important;
  }
  input[type="text" i] {
      padding-block: 1px;
      padding-inline: 2px;
  }
  .t-page {
    height: 100vh;
    width: 100vw;
    display: flex;

    .left {
      flex: 8;
      padding: 30px;
      background: #f8f9fa;
      border-right: 1px solid #eaeaea;
      overflow-y: auto;

      .section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;

          .section-title {
              font-size: 24px;
              font-weight: 600;
              color: rgba(199, 0, 11, 0.76);
          }

          .search-box {
              position: relative;
              width: 300px;

              i:nth-child(1) {
                  position: absolute;
                  left: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #777777;
              }
              i:nth-child(2) {
                  position: absolute;
                  right: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #777777;
              }

              .fa-solid, .fas {
                  font-weight: 900;
              }

              input {
                  width: 100%;
                  padding: 10px 40px 10px 40px;
                  border: 1px solid #eaeaea;
                  border-radius: 30px;
                  font-size: 14px;
                  transition: all 0.3s;

                  &:focus {
                    outline: none;
                    // border-color: rgba(199, 0, 11, 0.76);
                    // box-shadow: 0 0 0 2px rgba(199, 0, 11, 0.76);
                    border-bottom-color: rgba(228, 197, 199, 0.953);
                    border-left-color: rgba(228, 197, 199, 0.953);
                    box-shadow: rgba(199, 0, 11, 0.02) 0px 0px 0px 0.395233px;
                    border-right-color: rgba(228, 197, 199, 0.953);
                    border-top-color: rgba(228, 197, 199, 0.953);
                  }
              }
          }
      }
      .filter-tabs {
          display: flex;
          gap: 10px;
          margin-bottom: 25px;

          .filter-tab {
              padding: 8px 20px;
              background: #ffffff;
              border: 1px solid #eaeaea;
              border-radius: 30px;
              font-size: 14px;
              cursor: pointer;
              transition: all 0.3s;

              &.active {
                  background: rgba(199, 0, 11, 0.76);
                  color: white;
                  border-color: rgba(199, 0, 11, 0.76);
              }
          }
      }
      .exam-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 20px;

        .exam-card {
            background: #ffffff;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
            transition: all 0.3s;
            border: 1px solid #eaeaea;

            .exam-header {
                padding: 20px;
                background: rgba(199, 0, 11, 0.76);
                color: white;

                .exam-title {
                    font-size: 18px;
                    font-weight: 600;
                    margin-bottom: 5px;
                }
                .exam-meta {
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;
                    opacity: 0.9;
                }
            }
            .exam-body {
                padding: 20px;

                .exam-info {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 15px;
                    font-size: 14px;
                    color: #777777;
                }
                .exam-desc {
                    font-size: 14px;
                    color: #777777;
                    margin-bottom: 20px;
                    line-height: 1.5;
                }
                .exam-footer {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .exam-status {
                        display: inline-block;
                        padding: 5px 12px;
                        border-radius: 30px;
                        font-size: 12px;
                        font-weight: 500;

                        &.status-pending {
                            background: rgba(255, 193, 7, 0.2);
                            color: #ff9800;
                        }
                        &.status-failed {
                            background: rgba(255, 143, 123, 0.3);
                            color: #ff5c40;
                        }
                        &.status-completed {
                            background: rgba(76, 175, 80, 0.2);
                            color: #4caf50;
                        }
                    }
                    .btn {
                        padding: 8px 20px;
                        background: rgba(199, 0, 11, 0.76);
                        color: white;
                        border: none;
                        border-radius: 6px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.3s;
                        outline-width: 0px;
                        outline-color: none;

                        &.btn-outline {
                            background: transparent;
                            border: 1px solid rgba(199, 0, 11, 0.76);
                            color: rgba(199, 0, 11, 0.76);
                        }
                    }
                }
            }
        }
      }
    }
    .right {
      flex: 2;
      padding: 30px;
      background: #ffffff;
      overflow-y: auto;

      .info-card {
            background: #f8f9fa;
            border-radius: 12px;
            padding: 20px;
            margin-bottom: 25px;
        }
      .card-title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 15px;
        color: rgb(102, 102, 102);
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .info-item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            font-size: 14px;

            .info-label {
                color: #777777;
            }
            .info-value {
                font-weight: 500;
                
                .btn-downl {
                    cursor: pointer;
                    color: rgba(199, 0, 11, 0.76);
                }
            }
        }
      .progress-item {
            margin-bottom: 20px;

            .progress-header {
                display: flex;
                justify-content: space-between;
                margin-bottom: 8px;
                font-size: 14px;
            }

            .t-progress-bar {
                height: 8px;
                background: #e9ecef;
                border-radius: 4px;
                overflow: hidden;

                .t-progress-fill {
                    height: 100%;
                    background: rgba(199, 0, 11, 0.76);
                    border-radius: 4px;
                }
            }
       }
       .stats-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 15px;
            margin-top: 20px;

            .stat-card {
                background: #ffffff;
                border-radius: 10px;
                padding: 15px;
                text-align: center;
                box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);

                .stat-value {
                    font-size: 24px;
                    font-weight: 700;
                    color: rgba(199, 0, 11, 0.76);
                    margin-bottom: 5px;
                }
                .stat-label {
                    font-size: 12px;
                    color: #777777;
                }
            }
       }
      
    }
  }
</style>